import React, { useState, useEffect } from "react";
import { CSVLink } from "react-csv";

import MakeAPICall from "../../apiCalls/common";

import {
  getConsultsApiRoute,
  deleteConsultApiRoute,
  addNatureConsultApiRoute,
  editNatureConsultApiRoute,
  changeConsultSequenceApiRoute
} from "../../apiRoutes";

import { sortData } from "../../utils/commonMethods";

import Loader from "../../components/loader";
import CustomModal from "../../components/modal";
import Button from "../../components/button";
import ViewProfilePic from "../../components/viewProfilePic";
import CustomDataTable from "../../components/datatable/customDataTable";

import ConsultNatureForm from "../../containers/NatureOfConsult/consultNatureForm";
import EditConsultSequence from "../../containers/NatureOfConsult/editConsultSequence";

import ICNoImg from "../../assets/images/noimg.png";

const NatureOfConsultPage = () => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [apiCallParams, setApiCallParams] = useState(null);
  const [consultNatureList, setConsultNatureList] = useState([]);
  const [filteredConsultNatureList, setFilteredConsultNatureList] = useState(
    []
  );
  const [excelSheetData, setExcelSheetData] = useState([]);
  const [selConsult, setSelConsult] = useState(null);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currFilters, setCurrFilters] = useState({
    skip: 0,
    limit: 10
  });
  const [showTextModal, setShowTextModal] = useState(false);
  const [modalText, setModalText] = useState("");

  const [showImageViewModal, setShowImageViewModal] = useState(false);
  const [showDelModal, setShowDelModal] = useState(false);
  const [consultFormModalTitle, setConsultFormModalTitle] = useState("");
  const [showConsultFormModal, setShowConsultFormModal] = useState(false);
  const [showEditSeqModal, setShowEditSeqModal] = useState(false);

  let excelSheetHeader = [
    { label: "Sequence Number", key: "Sequence_Number" },
    { label: "Consult Image", key: "Consult_Image" },
    { label: "Consult Title", key: "Consult_Title" },
    { label: "Description", key: "Description" },
  ];

  const tableHeaders = [
    {
      key: "id",
      value: "Sequence No."
    },
    { key: "content", value: "Consult Title" },
    { key: "consultPic", value: "Consult Image" },
    { key: "Action", value: "Action" }
  ];

  // create custom table filter function
  const customSearchTableByText = query => {
    let newList = consultNatureList.filter(item => {
      if (item.id === parseInt(query)) {
        return true;
      } else if (item.content.toLowerCase().includes(query.toLowerCase())) {
        return true;
      }
      return false;
    });

    setFilteredConsultNatureList(newList);
  };

  const setTableFilters = filters => {
    if (filters.text && filters.text.length > 0) {
      customSearchTableByText(filters.text);
    } else {
      let newFilter = Object.assign({}, currFilters);
      newFilter.limit = filters.limit;
      newFilter.skip = filters.skip;

      setCurrFilters(newFilter);
    }
  };

  const sortTableDataByColumn = SelColumn => {
    let sortedData = sortData(
      SelColumn.column,
      SelColumn.order,
      filteredConsultNatureList
    );
    setFilteredConsultNatureList(sortedData);
  };

  // handle all data table pagination at frontend
  const filterConsultList = list => {
    let newList = [];
    if (list) {
      newList = list.slice(
        currFilters.skip,
        currFilters.skip + currFilters.limit
      );
    } else {
      newList = consultNatureList.slice(
        currFilters.skip,
        currFilters.skip + currFilters.limit
      );
    }

    setFilteredConsultNatureList(newList);
  };

  // get nature of consults
  const getConsults = () => {
    setIsProcessing(true);

    setApiCallParams({
      reqType: "GET",
      reqUrl: getConsultsApiRoute,
      params: {
        skip: 0,
        limit: 0
      },
      successCallback: async res => {
        let list = [];
        let excelList = [];
        await res.data.data.consultData.forEach((column, index) => {
          let d = {};
          let e = {};

          d._id = column._id;
          d.id = index + 1;
          d.content = column.consultName;
          d.consultPic =
            column.consultPic === null ||
            column.consultPic === undefined ||
            column.consultPic === ""
              ? ICNoImg
              : column.consultPic.original;
          d.description = column.description || '';

          d.isRedirect = column.isRedirect || false;
          d.redirectURL = column.redirectURL || '';

          e.Sequence_Number = index + 1;
          e.Consult_Title = column.consultName;
          e.Consult_Image =
            column.consultPic === null ||
            column.consultPic === undefined ||
            column.consultPic === ""
              ? ICNoImg
              : column.consultPic.original;
          d.Description = column.description || '';
          d.bannerType = column.bannerType || '';
          list.push(d);
          excelList.push(e);
        });
        setConsultNatureList(list);
        setTotalRecords(res.data.data.totalCount);
        setExcelSheetData(excelList);
        filterConsultList(list);
        setIsProcessing(false);
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // delete consult
  const delSelConsult = () => {
    setShowDelModal(false);
    setIsProcessing(true);

    let parm = {
      consultId: selConsult._id
    };

    setApiCallParams({
      reqType: "DELETE",
      reqUrl: deleteConsultApiRoute,
      params: parm,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Nature of Consult Deleted Successfully.");
        setShowTextModal(true);
        getConsults();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // add new consult
  const addNewConsult = values => {
    setShowConsultFormModal(false);
    setIsProcessing(true);

    setApiCallParams({
      reqType: "POST",
      reqUrl: addNatureConsultApiRoute,
      dataObj: values,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Nature of Consult Added Successfully.");
        setShowTextModal(true);
        getConsults();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // edit consult
  const editSelConsult = values => {
    setShowConsultFormModal(false);
    setSelConsult(null);
    setIsProcessing(true);

    setApiCallParams({
      reqType: "PUT",
      reqUrl: editNatureConsultApiRoute,
      dataObj: values,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Nature of Consult Updated Successfully.");
        setShowTextModal(true);
        getConsults();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  // update consult sequence
  const updateConsultSequence = newSeq => {
    setShowEditSeqModal(false);
    setIsProcessing(true);

    var array = [];
    for (var x = 0; x < newSeq.length; x++) {
      array.push({
          consultId: newSeq[x]._id,
          seqNo: x
      });
    }

    // var formData = new FormData();
    // formData.append("sequence", JSON.stringify(array));

    const dataToSend = {
      sequence: array
    }

    setApiCallParams({
      reqType: "PUT",
      reqUrl: changeConsultSequenceApiRoute,
      dataObj: dataToSend,
      successCallback: res => {
        setIsProcessing(false);
        setModalText("Sequence Changed Successfully");
        setShowTextModal(true);
        getConsults();
      },
      failureCallback: err => {
        setIsProcessing(false);
        // setModalText(
        //   "Please try again. Please contact Instant Consult Support on 1300 003 310 if this issue persists."
        // );
        // setShowTextModal(true);
      }
    });
  };

  useEffect(() => {
    if (consultNatureList.length === 0) {
      getConsults();
    }
    filterConsultList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currFilters]);

  const showConsultImage = item => {
    setSelConsult(item);
    setShowImageViewModal(true);
  };

  const showConsultAddModal = () => {
    setConsultFormModalTitle("Add Nature of Consult");
    setShowConsultFormModal(true);
  };

  const showConsultEditModal = item => {
    setSelConsult(item);
    setConsultFormModalTitle("Edit Nature of Consult");
    setShowConsultFormModal(true);
  };

  const showConsultDelModal = item => {
    setSelConsult(item);
    setShowDelModal(true);
  };

  return (
    <div className="view-ticket-container consult-nature-page-container">
      <CustomModal
        useOneButton={true}
        cancelText="OKAY"
        openModal={showTextModal}
        cancelEvent={() => {
          setShowTextModal(false);
          setModalText("");
        }}
        modalBodyContent={<p className="text-center mb-0">{modalText}</p>}
      />
      <CustomModal
        openModal={showImageViewModal}
        cancelEvent={() => {
          setShowImageViewModal(false);
          setSelConsult(null);
        }}
        title="View Consult Image"
        modalBodyContent={
          <ViewProfilePic
            profileImg={selConsult !== null ? selConsult.consultPic : ICNoImg}
          />
        }
        noFooterButtons={true}
      />
      <CustomModal
        openModal={showEditSeqModal}
        cancelEvent={() => {
          setShowEditSeqModal(false);
        }}
        title="Edit Sequence"
        modalBodyContent={
          <EditConsultSequence
            consults={consultNatureList}
            onUpdate={updateConsultSequence}
          />
        }
        noFooterButtons={true}
      />
      <CustomModal
        className="modal-lg"
        openModal={showConsultFormModal}
        cancelEvent={() => {
          setShowConsultFormModal(false);
          setSelConsult(null);
        }}
        title={consultFormModalTitle}
        modalBodyContent={
          <ConsultNatureForm
            consult={selConsult}
            onAddSubmit={addNewConsult}
            onEditSubmit={editSelConsult}
          />
        }
        noFooterButtons={true}
      />
      <CustomModal
        okayText="Yes"
        cancelText="No"
        openModal={showDelModal}
        cancelEvent={() => {
          setShowDelModal(false);
          setSelConsult(null);
        }}
        okayEvent={delSelConsult}
        modalBodyContent={
          <p className="text-center mb-0">
            {"Are you sure you want to delete " +
              (selConsult !== null ? selConsult.content : "") +
              "?"}
          </p>
        }
      />
      {isProcessing && <Loader />}
      <div className={isProcessing ? "disableContainer" : ""}>
        <div className="d-flex flex-row flex-wrap justify-content-between">
          <h3>Nature of Consult</h3>
          <div className="d-flex flex-row align-items-end">
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Button
              clickEvent={() => {
                setShowEditSeqModal(true);
              }}
              title="Edit Sequence"
            ></Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <Button
              clickEvent={showConsultAddModal}
              title="Add Nature of Consult"
            ></Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <CSVLink
              className="no-text-decoration"
              filename={"Nature_of_Consult.csv"}
              data={excelSheetData}
              headers={excelSheetHeader}
            >
              <Button title="Export to CSV"></Button>
            </CSVLink>
          </div>
        </div>
        <CustomDataTable
          totalRecords={totalRecords}
          headers={tableHeaders}
          setFilters={setTableFilters}
          sortData={sortTableDataByColumn}
          tabFilters={currFilters}
        >
          {filteredConsultNatureList.map((item, index) => (
            <tr key={index}>
              <td>{item.id}</td>
              <td>{item.content}</td>
              <td>
                <div className="d-flex flex-column position-relative">
                  <img
                    className="rounded-circle-0 consult-nature-img mb-2"
                    src={item.consultPic}
                    alt="consult-nature-img"
                  />
                  <button
                    onClick={() => {
                      showConsultImage(item);
                    }}
                    type="button"
                    className="btn ic-btn-transparent"
                  >
                    View & Download
                  </button>
                </div>
              </td>
              <td>
                <button
                  type="button"
                  className="btn btn-out-bell high-z-index ml-2"
                  onClick={() => {
                    showConsultEditModal(item);
                  }}
                >
                  <i className="fas fa-edit"></i>
                </button>
                <button
                  onClick={() => {
                    showConsultDelModal(item);
                  }}
                  type="button"
                  className="btn btn-out-delete high-z-index ml-2"
                >
                  <i className="fas fa-trash-alt"></i>
                </button>
              </td>
            </tr>
          ))}
        </CustomDataTable>
        {/* API Call */}
        <MakeAPICall apiParam={apiCallParams} />
      </div>
    </div>
  );
};

export default NatureOfConsultPage;
